
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "EyresBrooks",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/EyresBrooks.vue